import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import { Table, Button, Select } from 'antd';
import { Link, useNavigate } from 'react-router-dom';

const { Option } = Select;

const WardList = () => {
  const navigate = useNavigate();
  const [wards, setWards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [size] = useState(16);
  const [sortField, setSortField] = useState('id');
  const [sortOrder, setSortOrder] = useState('desc');

  const API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/ward';

  useEffect(() => {
    const fetchWards = async () => {
      try {
        const response = await axios.get(`${API_URL}/pagination`, {
          params: { page, size, sortBy: sortField, sortOrder },
        });
        setWards(response.data.content);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchWards();
  }, [page, size, sortField, sortOrder]);

  if (error) {
    return <div className="text-center text-red-500 mt-4">Error: {error.message}</div>;
  }

  const columns = [
    { title: 'क्र.सं', dataIndex: 'id', key: 'id' },
    { title: 'वडाको नाम', dataIndex: 'name', key: 'name' },
    { title: 'फोन', dataIndex: 'phone', key: 'phone' },
    { title: 'इमेल', dataIndex: 'email', key: 'email' },
    {
      title: 'विवरण',
      key: 'details',
      render: (text, record) => (
        <Link
          to={`/ward/${record.id}/details`}
          className="text-blue-500 hover:underline"
        >
          बिस्तृत विवरण
        </Link>
      ),
    },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-1 pt-20 px-6 md:px-10">
        <Sidebar />
        <div className="w-full md:ml-64 p-5 pt-10">
          <h1 className="text-2xl font-semibold mb-6 text-center md:text-left">वडाको सुची</h1>

          {/* Sorting Section */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
            <div className="flex items-center gap-4">
              <label className="text-sm">Sort By:</label>
              <Select
                onChange={(value) => setSortField(value)}
                value={sortField}
                className="w-32"
              >
                <Option value="id">क्र.सं.</Option>
                <Option value="wardName">वडाको नाम</Option>
                <Option value="wardNumber">वाडाको नम्बर</Option>
              </Select>
              <label className="text-sm">Order:</label>
              <Select
                onChange={(value) => setSortOrder(value)}
                value={sortOrder}
                className="w-32"
              >
                <Option value="asc">माथिबाट</Option>
                <Option value="desc">तलबाट</Option>
              </Select>
            </div>

            {/* Buttons */}
            <div className="flex flex-wrap gap-4">
              <Button
                type="primary"
                size="large"
                onClick={() => navigate('/ward/add')}
              >
                वडा थप गर्नुहोस
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={() => navigate('/people-representative/add')}
              >
                जनप्रतिनिधि थप गर्नुहोस
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={() => navigate('/ward-staff/add')}
              >
                वडाको कर्मचारी थप गर्नुहोस
              </Button>
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto">
            <Table
              dataSource={wards}
              columns={columns}
              pagination={false}
              loading={loading}
              bordered
              className="custom-table w-full"
            />
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-end mt-4 gap-4">
            <Button
              onClick={() => setPage(page - 1)}
              disabled={page === 0}
              className="btn-primary"
            >
              Previous
            </Button>
            <Button
              onClick={() => setPage(page + 1)}
              disabled={page >= totalPages - 1}
              className="btn-primary"
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WardList;
